var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"qir-form-section-background-shapes__wrapper"})}
var staticRenderFns = []

export { render, staticRenderFns }